import { FormatTypes } from 'Lib/Format';
import moment from 'moment';
import { Field, TextOutput } from '../../Core';
import { ListFieldSection, PageSection } from '../../Layout';
import StandardizationRecordSection from './StandardizationRecordSection';

const GaugeStandardisationSingular = () => {
  return (
    <PageSection>
      <ListFieldSection>
        <Field
          input={<TextOutput />}
          label="Today's Date"
          //value={new Intl.DateTimeFormat(localTimeZoneFormat).format(moment().toDate())}
          value={moment().format('YYYY-MM-DD')}
          format={{ type: FormatTypes.Date }}
        />
      </ListFieldSection>
      <StandardizationRecordSection />
    </PageSection>
  );
};

export default GaugeStandardisationSingular;
export { GaugeStandardisationSingular };
